import { render, staticRenderFns } from "./mien.vue?vue&type=template&id=5989ab31&"
import script from "./mien.vue?vue&type=script&lang=js&"
export * from "./mien.vue?vue&type=script&lang=js&"
import style0 from "./mien.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports